import { Navigate, Route, Routes } from 'react-router-dom';

import { Layout } from './components/Layout';
import { useAuth } from './lib/auth';
import { Digest } from './pages/Digest';
import { DigestDetail } from './pages/DigestDetail';
import { Digests } from './pages/Digests';
import { Items } from './pages/Items';
import { Login } from './pages/Login';
import { RoutingRules } from './pages/RoutingRules';
import { Sources } from './pages/Sources';

export function App(): JSX.Element {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Navigate to="/digests" replace />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/digests"
          element={
            <RequireAuth>
              <Digests />
            </RequireAuth>
          }
        />
        <Route
          path="/digests/:week"
          element={
            <RequireAuth>
              <DigestDetail />
            </RequireAuth>
          }
        />
        <Route
          path="/sources"
          element={
            <RequireAuth>
              <Sources />
            </RequireAuth>
          }
        />
        <Route
          path="/routing-rules"
          element={
            <RequireAuth>
              <RoutingRules />
            </RequireAuth>
          }
        />
        <Route
          path="/items"
          element={
            <RequireAuth>
              <Items />
            </RequireAuth>
          }
        />
        <Route
          path="/digest/trigger"
          element={
            <RequireAuth>
              <Digest />
            </RequireAuth>
          }
        />
        <Route path="*" element={<Navigate to="/digests" replace />} />
      </Route>
    </Routes>
  );
}

function RequireAuth({ children }: { readonly children: JSX.Element }): JSX.Element {
  const auth = useAuth();
  if (auth.status === 'loading') {
    return (
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 text-center text-2xs font-mono text-ink-muted">
        …
      </div>
    );
  }
  if (auth.status !== 'signed-in') {
    return <Navigate to="/login" replace />;
  }
  return children;
}
